/* t leaf T — Tea Canister Refresh form logic.
   Save this file in the theme as: assets/tea-canister-refresh.js
   Loaded only on the tea-canister-refresh page via
   templates/page.tea-canister-refresh.liquid — do not add it to theme.liquid
   globally, it only needs to run on this one page. */
(function () {
  var FORMSPREE_URL = "https://formspree.io/f/xbgjvjvv";

  var TEA_DATA = {
    "Black tea blends": ["English breakfast", "English breakfast organic", "New Zealand Breakfast", "Extra strength breakfast", "Lapsang souchong", "Wellington breakfast"],
    "Flavoured black teas": ["Earl grey blue flower", "French earl grey", "Earl grey organic", "Orange", "Chai", "Christmas tea"],
    "Herbal teas": ["Peppermint", "Peppermint organic", "Kawakawa fire", "Restful", "Chamomile", "Hibiscus", "Honeyed chamomile", "Turmeric chai", "Energise"],
    "Fruit teas": ["Berrylicious", "Lemon sorbet", "Berry", "Peach apricot"],
    "Green teas": ["Gunpowder organic", "Sencha organic"],
    "Flavoured green teas": ["Tokyo lime", "Zen garden", "High Grade Jasmine"],
    "Rooibos tea": ["Red vanilla raspberry"]
  };

  var categoriesEl = document.getElementById("tlt-tea-categories");
  var pickerWrap = document.getElementById("tlt-tea-picker-wrap");
  var picker = document.getElementById("tlt-tea-picker");
  var addTeaBtn = document.getElementById("tlt-add-tea-btn");
  var addManualBtn = document.getElementById("tlt-add-manual-btn");
  var linesEl = document.getElementById("tlt-tea-lines");
  var emptyMsg = document.getElementById("tlt-empty-msg");
  var submitBtn = document.getElementById("tlt-submit-btn");
  var statusEl = document.getElementById("tlt-form-status");
  var businessInput = document.getElementById("tlt-business-name");
  var emailInput = document.getElementById("tlt-contact-email");
  var commentsInput = document.getElementById("tlt-comments");

  // If this page's HTML isn't present, do nothing (safety check in case the
  // template is ever reused elsewhere).
  if (!categoriesEl || !submitBtn) { return; }

  var lineCounter = 0;
  var activeCategoryBtn = null;

  function categoryButtonStyle(active) {
    return [
      "display:inline-block",
      "padding:9px 16px",
      "border-radius:20px",
      "font-size:0.95em",
      "cursor:pointer",
      "border:1.5px solid #D2451E",
      active ? "background:#D2451E;color:#ffffff;" : "background:#ffffff;color:#D2451E;"
    ].join(";");
  }

  Object.keys(TEA_DATA).forEach(function (category) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = category;
    btn.setAttribute("style", categoryButtonStyle(false));
    btn.addEventListener("click", function () {
      if (activeCategoryBtn) { activeCategoryBtn.setAttribute("style", categoryButtonStyle(false)); }
      btn.setAttribute("style", categoryButtonStyle(true));
      activeCategoryBtn = btn;

      picker.innerHTML = "";
      var placeholder = document.createElement("option");
      placeholder.textContent = "Select a " + category.toLowerCase() + " variety…";
      placeholder.value = "";
      picker.appendChild(placeholder);

      TEA_DATA[category].forEach(function (tea) {
        var opt = document.createElement("option");
        opt.value = tea;
        opt.textContent = tea;
        picker.appendChild(opt);
      });

      pickerWrap.style.display = "flex";
    });
    categoriesEl.appendChild(btn);
  });

  function updateEmptyMsg() {
    emptyMsg.style.display = linesEl.children.length ? "none" : "block";
  }

  function addLine(value) {
    lineCounter += 1;
    var row = document.createElement("div");
    row.setAttribute("data-line", lineCounter);
    row.setAttribute("style", "display:flex;align-items:center;gap:8px;margin-bottom:8px;");

    var input = document.createElement("input");
    input.type = "text";
    input.value = value || "";
    input.placeholder = "Tea name";
    input.setAttribute("style", "flex:1;padding:9px 12px;border:1px solid #cccccc;border-radius:4px;font-size:1em;box-sizing:border-box;");

    var removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.textContent = "×";
    removeBtn.setAttribute("aria-label", "Remove line");
    removeBtn.setAttribute("style", "background:none;border:none;color:#888888;font-size:1.3em;line-height:1;cursor:pointer;padding:4px 8px;");
    removeBtn.addEventListener("click", function () {
      row.remove();
      updateEmptyMsg();
    });

    row.appendChild(input);
    row.appendChild(removeBtn);
    linesEl.appendChild(row);
    updateEmptyMsg();
    input.focus();
  }

  addTeaBtn.addEventListener("click", function () {
    if (!picker.value) { return; }
    addLine(picker.value);
    picker.value = "";
  });

  addManualBtn.addEventListener("click", function () {
    addLine("");
  });

  submitBtn.addEventListener("click", function () {
    var teaValues = Array.prototype.slice.call(linesEl.querySelectorAll("input[type='text']"))
      .map(function (i) { return i.value.trim(); })
      .filter(function (v) { return v.length > 0; });

    if (!businessInput.value.trim()) {
      statusEl.textContent = "Please enter your cafe or business name.";
      statusEl.style.color = "#c0392b";
      businessInput.focus();
      return;
    }
    if (teaValues.length === 0) {
      statusEl.textContent = "Please add at least one tea to your list before submitting.";
      statusEl.style.color = "#c0392b";
      return;
    }

    var payload = {
      business_name: businessInput.value.trim(),
      _replyto: emailInput.value.trim(),
      tea_count: teaValues.length,
      tea_list: teaValues.join("\n"),
      comments: commentsInput.value.trim(),
      _subject: "Tea Canister Refresh: " + businessInput.value.trim()
    };
    teaValues.forEach(function (tea, idx) {
      payload["tea_" + (idx + 1)] = tea;
    });

    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting…";
    statusEl.style.color = "#444444";
    statusEl.textContent = "Sending your list…";

    fetch(FORMSPREE_URL, {
      method: "POST",
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (response.ok) {
        statusEl.style.color = "#2e7d32";
        statusEl.textContent = "Thanks. Your tin list has been received. You can submit again any time your list changes.";
        submitBtn.textContent = "Submitted";
      } else {
        return response.json().then(function (data) {
          throw new Error((data && data.error) || "Submission failed");
        });
      }
    }).catch(function () {
      statusEl.style.color = "#c0392b";
      statusEl.textContent = "Something went wrong sending your list. Please try again, or email us directly.";
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit my tin list";
    });
  });

  updateEmptyMsg();
})();
